export default __webpack_public_path__ + "static/media/logo1.5d704e17.svg";